
<div class="image-upload" :class="['dropbox', { active: Boolean(imageSrc) }]">
  <label>{{ label }}</label>

  <input
    ref="input"
    type="file"
    accept="image/jpeg, image/png"
    :name="name"
    @change="handleChange"
  />

  <img
    v-show="imageSrc"
    :src="imageSrc"
    :width="width"
    :height="height"
  />

  <a
    v-show="imageSrc"
    class="remove link"
    @click="remove"
  >
    Remove
  </a>

  <div v-show="!imageSrc" class="empty">
    <icon class="icon" :name="icon" />
    <div>{{ placeholder }}</div>
  </div>
</div>
